<section id="main" class="bg-light">
     <div id="content" class="container">
          <div>
               <div class="row" *ngIf="showValidationMessage">
                    <div class="col-12">
                         <div class="alert alert-danger" role="alert">
                              <p class="mb-0" [innerHtml]="'confirmAssentValidation' | translator: 'audit'">
                                   Consent must be indicated before proceeding.
                              </p>
                         </div>
                    </div>
               </div>
               <section *ngIf="showMustConsent" class="row mb-3">
                    <div class="col-12">
                         <h1 [innerHtml]="'confirmAssentHeader' | translator: 'audit'">
                              Confirm Driver Disclosure and Authorization to View Report
                         </h1>
                         <div class="mb-3">
                              <div class="form-check mb-3">
                                   <label class="form-check-label">
                                        <input type="checkbox" 
                                             [(ngModel)]="hasConfirmedConsent"
                                             [title]="'confirmAssentCheckBoxTitle' | translator: 'audit'"
                                             class="form-check-input"
                                        />
                                        <span [innerHtml]="'confirmAssentCheckBoxText' | translator: 'audit'">
                                             I certify under penalty of perjury that the company 
                                             I represent has disclosed to the driver that his or her PSP record will be accessed and that the driver has given my company 
                                             authorization to access his or her PSP record. I understand this record will be available for viewing for five days (120 hours) 
                                             from the time of purchase.
                                        </span>
                                   </label>
                              </div>
                              <div class="">
                                   <button 
                                        class="btn btn-primary btn-strong mb-3 me-2"
                                        [title]="'confirmAssentCheckBoxTitle' | translator: 'audit'"
                                        (click)="submit()"
                                   >
                                        <span  [innerHtml]="'confirmAssentCheckBoxTitle' | translator: 'audit'">
                                             Confirm Driver Disclosure and Authorization
                                        </span>
                                   </button>
                                   <button class="btn btn-light mb-3"
                                        [title]="'cancel_button' | translator: 'base'"
                                        (click)="toDashboard()"
                                        [innerHtml]="'cancel_button' | translator: 'base'"
                                   >
                                        Cancel
                                   </button>
                              </div>
                         </div>
                    </div>
               </section>
               <section *ngIf="showCanViewRecord" class="row">
                    <div class="col-12">
                         <h1 class="page-title" [innerHtml]="'viewRecordAfterConsentTitle' | translator: 'audit'">View Driver Record</h1>
                         <p [innerHtml]="'viewRecordPdfHtmlText' | translator: 'audit'">
                              There are two options for viewing your PSP Record: HTML (as a web page) or PDF (as a document you can download). View your record by clicking the appropriate button below:"
                         </p>
                         <p>
                              <button
                                   (click)="showInBrowser()"
                                   class="btn btn-primary me-2"
                                   name="Download"
                                   [title]="'View' | translator: 'driver'"
                              >HTML
                              </button>
                              <button
                                   (click)="downloadPdf()"
                                   class="btn btn-primary"
                                   [title]="'Download' | translator: 'audit'"
                                   name="download-document"
                              >PDF
                              </button>
                         </p>
                         <p>
                              <span [innerHtml]="'viewRecordAdobeText_1' | translator: 'audit'">
                                   If you need a way to view the PDF document, you can 
                              </span>
                              <a 
                                   title="Adobe PDF" 
                                   href='http://get.adobe.com/reader/' 
                                   target='_blank'
                                   [innerHtml]="'viewRecordAdobeText_2' | translator: 'audit'"
                              >download the free Adobe PDF Reader</a>.
                         </p>
                    </div>
               </section>
               <section *ngIf="showPendingUnderReview" class="row">
                    <div class="col-12">
                         <h1 [innerHtml]="'underReviewTitle' | translator: 'audit'">Driver Disclosure and Authorization Form - Under Review</h1>
                         <p [innerHtml]="'underReviewText' | translator: 'audit'">
                              Your account is in probation status. Before you may view this driver's PSP report, a legible copy of this driver's disclosure and authorization 
                              form must be submitted and approved. The PSP customer service team is currently reviewing the form that was submitted for this PSP record request. 
                              The person who uploaded the driver disclosure and authorization form will be notified via email when the PSP record is available to view."
                         </p>
                         <p>
                              <button class="btn btn-outline-primary"
                                   (click)="toDashboard()"
                                   [title]="'returnToDashboard' | translator: 'audit'"
                                   [innerHtml]="'returnToDashboard' | translator: 'audit'"
                              >
                                   Return to Dashboard
                              </button>
                         </p>
                    </div>
               </section>
               <section *ngIf="showProbationUpload" class="row">
                    <div class="col-12">
                         <h1 [innerHtml]="'uploadProbationTitle' | translator: 'audit'">Upload Proof of Driver Disclosure and Authorization</h1>
                         <p *ngIf='isResubmit'
                              class="alert alert-warning"
                              [innerHtml]="'resubmitProbationModalText' | translator: 'customer'"
                         >
                              The previously submitted disclosure and authorization form did not meet requirements. Please resubmit.
                         </p>
                         <p [innerHtml]="'uploadProbationText' | translator: 'audit'">
                              Your account is currently in probation status. During probation, your company must submit a legible copy of the driver's disclosure and authorization form 
                              for each PSP record requested. You may upload the driver disclosure and authorization form at this time. <em>The driver disclosure and authorization form 
                              must be either a PDF, JPEG or PNG file type.</em>
                         </p>
                         <p>
                              <button
                                   type="button"
                                   class="btn btn-primary"
                                   [title]="'submitProbationDocsBtn' | translator: 'audit'"
                                   (click)="openSubmitDialog()"
                                   [innerHtml]="'submitProbationDocsBtn' | translator: 'audit'"
                              >
                                   Upload forms
                              </button>
                         </p>
                         <p [innerHtml]="'uploadProbationText2' | translator: 'audit'">
                              Alternatively, you may fax or email the driver disclosure and authorization form. Click the link below for a fax cover sheet or pre-filled email form.
                         </p>
                         <p>
                              <button
                                   type="button"
                                   class="btn btn-primary"
                                   [title]="'submitFaxBtn' | translator: 'audit'"
                                   (click)="generateFaxCoverSheet()"
                                   [innerHtml]="'submitFaxBtn' | translator: 'audit'"
                              >
                                   Download fax cover sheet
                              </button>
                         </p>
                    </div>
               </section>
               <section *ngIf="showExpiredOrError" class="row">
                    <div class="col-12">
                         <h1 [innerHtml]="'errorTitle' | translator: 'audit'">Driver Record Error</h1>
                         <p class="alert alert-danger">
                              {{message}}
                         </p>
                         <p>
                              <button class="btn btn-outline-primary"
                                   (click)="toDashboard()"
                                   [title]="'returnToDashboard' | translator: 'audit'"
                                   [innerHtml]="'returnToDashboard' | translator: 'audit'"
                              >
                                   Return to Dashboard
                              </button>
                         </p>
                    </div>
               </section>

               <ng-template #UploadModal let-modal>
                    <div class="modal-header">
                         <h3
                              id="uploadModalTitle" 
                              class="modal-title"
                              slot="header"
                         >
                              <span [innerHtml]="'uploadModalTitle' | translator: 'audit'">Add document for driver:</span> {{transactionData.lastName}}
                         </h3>
                    </div>
                    <div class="modal-body">
                         <div
                              class="overlay"
                              *ngIf="isUploading"
                         >
                         <h1 class="heading" [innerHtml]="'Processing' | translator: 'base'">Processing...</h1>
                         </div>
                         <p [innerHtml]="'UploadModalText1' | translator: 'audit'">
                              Add one or more files here to complete your document submission.
                         </p>
                         <div class="alert alert-warning">
                              <span
                                   class="pl-1"
                                   [innerHtml]="'formsText5' | translator: 'audit'"
                              > 
                                   The driver's name, signature, and date must be included on the forms. Please remove or black out any other personally identifiable 
                                   information, like date of birth, social security number, license number, etc.
                              </span>
                         </div>
                         <h4
                              [innerHtml]="'uploadedFilesHeader' | translator: 'audit'"
                              class="h5"
                         >
                              Uploaded files
                         </h4>
                         <p
                              class="text-center no-files-message"
                              *ngIf="probationDocuments.length === 0"
                              [innerHtml]="'noDocAttempts' | translator: 'audit'"
                         >
                              No files uploaded yet.
                         </p>
                         <div
                              class="modal-submitted-documents"
                              *ngIf="probationDocuments.length > 0"
                         >
                              <table class="table table-vcr table-light table-collapsible">
                                   <thead>
                                        <tr>
                                             <th scope="col" [innerHtml]="'docHeaderCol1' | translator: 'audit'">Submitted By</th>
                                             <th scope="col" [innerHtml]="'docHeaderCol2' | translator: 'audit'">Received</th>
                                             <th scope="col" [innerHtml]="'docHeaderCol3' | translator: 'audit'">Action</th>
                                        </tr>
                                   </thead>
                                   <tbody>
                                        <tr *ngFor="let doc of probationDocuments; let i = index;">
                                             <td class="text-break">
                                                  <span 
                                                       class="cell-label" 
                                                       [innerHtml]="'docHeaderCol1' | translator: 'audit'"
                                                  >
                                                       Submitted By
                                                  </span>                                
                                                  {{doc.creator}}
                                             </td>
                                             <td class="text-break">
                                                  <span 
                                                       class="cell-label" 
                                                       [innerHtml]="'docHeaderCol2' | translator: 'audit'"
                                                  >
                                                       Received
                                                  </span>                              
                                                  {{ doc.created }}
                                             </td>
                                             <td>
                                                  <span 
                                                       class="cell-label" 
                                                       [innerHtml]="'docHeaderCol3' | translator: 'audit'"
                                                  >
                                                       Action
                                                  </span>                               
                                                  <button
                                                       *ngIf="doc.mimeTypeId === 2 || doc.mimeTypeId === 4"
                                                       class='btn btn-primary btn-sm me-2 mb-2'
                                                       (click)="showPdfDocument(doc.documentId)"
                                                       [title]="'View' | translator: 'driver'"
                                                       [id]="'viewPdf' + doc.documentId"
                                                       [innerHtml]="'View' | translator: 'driver'"
                                                  >
                                                       View
                                                  </button>
                                                  <button
                                                       *ngIf="doc.mimeTypeId !== 2 || doc.mimeTypeId === 4"
                                                       class='btn btn-primary btn-sm me-2 mb-2'
                                                       (click)="showDocument(doc.documentId)"
                                                       [title]="'View' | translator: 'driver'"
                                                       [id]="'viewImg' + doc.documentId"
                                                       [innerHtml]="'View' | translator: 'driver'"
                                                  >
                                                       View
                                                  </button>
                                                  <button
                                                       (click)="removeDocument(doc.documentId)"
                                                       [title]="'btnRemove' | translator: 'audit'"
                                                       class="btn btn-danger btn-sm mb-2"
                                                       [id]="'remove' + doc.documentId"
                                                       [innerHtml]="'btnRemove' | translator: 'audit'"
                                                  >
                                                       Remove
                                                  </button>
                                             </td>
                                        </tr>
                                   </tbody>
                              </table>                      
                         </div>
                         <h4
                              [innerHtml]="'addDocumentsHeader' | translator: 'audit'"
                              class="h5"
                         >
                              Add document(s)
                         </h4>
                         <div class="file-upload-container">
                         <label for="uploadDocumentsId" class="file-upload-label d-block position-relative overflow-hidden">
                              <input type="file" 
                                   class="file-upload-input bg-light form-control d-block overlayed" 
                                   accept=".jpg, .jpeg, .png, .pdf" 
                                   multiple 
                                   (change)="uploadDocuments($event)" 
                                   id="uploadDocumentsId"
                              >								
                              <span class="file-upload-overlay overlayed">
                                   <div class="text-center px-3" aria-describedby="uploadDocumentsId">
                                        <strong>
                                             <span [innerHtml]="'docUploadChooseOrDrop1' | translator: 'audit'">
                                                  Choose File(s)
                                             </span>
                                             <span class="ms-1" [innerHtml]="'docUploadChooseOrDrop2' | translator: 'audit'">
                                                  or drag and drop file(s) here.
                                             </span>
                                        </strong>
                                   </div>
                              </span>
                              <span class="file-upload-overlay-focus overlayed pe-none"></span>
                         </label>
                         </div>
                         <div class="help-block pt-2 mb-3">
                              <span
                                   class="fw-bold"
                                   [innerHtml]="'AcceptableFormats' | translator: 'audit'"
                              >
                                   Acceptable formats are PDF, JPG, and PNG.
                              </span>
                         </div>
                    </div>
                    <div class="modal-footer">
                         <button
                              class="btn btn-primary"
                              (click)="completeDocumentUploads()"
                              [title]="'submitDocsBtn' | translator: 'audit'"
                              id="btnMakeDefaultOk"
                              name="btnMakeDefaultOk"
                              [disabled]="probationDocuments && probationDocuments.length === 0"
                         >
                              <span
                                   class="pr-2"
                                   [innerHtml]="'submitDocsBtn' | translator: 'audit'"
                              >
                                   Submit Document(s)
                              </span>
                         </button>
                         <button
                              class="btn btn-outline-primary me-2"
                              (click)="cancelUploads()"
                              [title]="'cancel_button' | translator: 'base'"
                              id="btnMakeDefaultCancel"
                              name="btnMakeDefaultCancel"
                              [innerHtml]="'cancel_button' | translator: 'base'"
                         >
                              Cancel
                         </button>
                    </div>
               </ng-template>

               <ng-template #InvalidFileTypeModal let-modal>
                    <div class="modal-header">
                         <h3
                              id="invalidFileTypeModalTitle" 
                              class="modal-title"
                              slot="header"
                              [innerHtml]="'invalidFileTypeTitle' | translator: 'audit'"
                         >
                              Invalid File Type
                         </h3>
                    </div>
                    <div class="modal-body">
                         <div class="alert alert-warning">
                              <span [innerHtml]="'invalidFileTypeText' | translator: 'audit'">
                                   You can only upload PDF, JPG, PNG, or JPEG files|
                              </span>
                         </div>
                    </div>
                    <div class="modal-footer">
                         <button class="btn btn-primary"
                              [title]="'ok_button' | translator: 'base'"

                              name="okay" 
                              (click)="closeInvalidFileTypeModal()"
                              [innerHtml]="'ok_button' | translator: 'base'"

                         >
                              OK
                         </button>
                    </div>
               </ng-template>

               <div *ngIf="isLoading"
                    class="overlay"
               >
                    <h1
                         class="heading"
                         [innerHtml]="'Loading' | translator: 'base'"
                    >
                         Loading...
                    </h1>
                    <img
                         [alt]="'Loading' | translator: 'base'"
                         name="Loading"
                    />
               </div>
               <div *ngIf="isSaving"
                    class="overlay"
               >
                    <h1
                         class="heading"
                         [innerHtml]="'SavingLoaderText' | translator: 'base'"
                    >
                         Saving...
                    </h1>
                    <img alt="Loading" />
               </div>
          </div>
     </div>
</section>     
